<template>
  <v-tabs v-model="tab" grow class="overflow-visible" height="35px" bg-color="toolbar">
    <v-tab
      value="model"
      :prepend-icon="componentWidth > widthBreakpoint ? 'mdi-sitemap' : undefined"
      min-width="60"
      style="width: 50%"
      ><div v-if="componentWidth > widthBreakpoint">Model</div>
      <div v-else><v-icon>mdi-sitemap</v-icon></div></v-tab
    >

    <v-tab
      value="appearance"
      :prepend-icon="componentWidth > widthBreakpoint ? 'mdi-palette' : undefined"
      min-width="60"
      style="width: 50%"
      ><div v-if="componentWidth > widthBreakpoint">Appearance</div>
      <div v-else><v-icon>mdi-palette</v-icon></div></v-tab
    >
  </v-tabs>
</template>

<script setup lang="ts">
import { computed } from "vue";

// eslint-disable-next-line @typescript-eslint/no-explicit-any
const compProps = defineProps<{ componentWidth: number; tab: any }>();

const emit = defineEmits(["update:tab"]);

const widthBreakpoint = 250;

const tab = computed({
  get() {
    return compProps.tab;
  },
  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  set(tab: any) {
    emit("update:tab", tab);
  },
});
</script>
